export enum Views {
  INSPECTION_DEVICE_EVENTS = 'inspection-device-events',
  TABLET_DEVICE_EVENTS = 'tablet-events',
  TCU_EVENTS = 'tcu-events',
  RFID_EVENTS = 'rfid-events',
  DEVICE_VIEW = 'device-view'
}
